export default __webpack_public_path__ + "media/images/elephant_ui_plane-ddb68441d4059703283d64238f8ec269.svg";